import * as React from "react";
const SvgFiRrBall = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ball_svg__a)">
      <path
        fill="#062147"
        d="M20.5 17a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m0 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m3.447-19.562a3 3 0 0 0-5.435-1.114L7.785 17.539a.958.958 0 0 1-1.596.059.96.96 0 0 1-.04-1.066 3 3 0 1 0-5.107-3.147 6.96 6.96 0 0 0 7.533 10.424 6.89 6.89 0 0 0 4.3-3.091L23.485 4.68a2.99 2.99 0 0 0 .462-2.243m-12.757 17.2a4.96 4.96 0 0 1-8.446-5.2 1 1 0 1 1 1.7 1.049 2.96 2.96 0 0 0 5.026 3.129l4.779-7.223 1.667 1.1zM21.827 3.562l-.007.01-4.8 7.256-1.667-1.1 4.82-7.287a1 1 0 0 1 1.655 1.124z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBall;
